// extracted by mini-css-extract-plugin
module.exports = {"addNewCard":"styles_addNewCard__pbdjS","card":"styles_card__1aUqo","inputArea":"styles_inputArea__2xCC3","input":"styles_input__1za0A","addButton":"styles_addButton__1AXDm"};